import { apiCall } from "../configs/axiosConfigs";
const BASE_URL = `/ecommerce/products`;

const withQuery = (base, params) => {
  if (!params) return base;
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return qs ? `${base}?${qs}` : base;
};

export const productsApi = {
  async getProducts(payload) {
    return apiCall({
      url: `${BASE_URL}/paginated`,
      method: "GET",
      data: payload
    });
  },
  async getVariationsByProductMaster(idProductoMaster) {
    return apiCall({
      url: `${BASE_URL}/variations`,
      method: "POST",
      data: { idProductoMaster }
    });
  }
};

export const urlMakePageFetcherProducts = {
  url: "/ecommerce/products/paginated",
  method: "GET"
};

export { withQuery };
